// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-basics-jsx": () => import("/opt/build/repo/src/pages/basics.jsx" /* webpackChunkName: "component---src-pages-basics-jsx" */),
  "component---src-pages-index-jsx": () => import("/opt/build/repo/src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

